import { storageKeys } from "Utils/localStorageUtils";

/**
 * Checks if the zone selector should be enabled based on the number of semantic maps
 * @param semanticMapsCount - The number of available semantic maps
 * @returns true if the selector should be enabled, false otherwise
 */
export const isZoneSelectorEnabled = (semanticMapsCount: number): boolean => {
  return semanticMapsCount >= 2;
};

/**
 * Saves the selected semantic map ID to localStorage
 * @param semanticMapId - The ID of the semantic map to save
 */
export const saveSemanticMapIdToStorage = (
  semanticMapId: string | null
): void => {
  localStorage.setItem(
    storageKeys.CURRENT_SEMANTIC_MAP_ID,
    JSON.stringify(semanticMapId)
  );
};
